import { defineStore } from 'pinia';
import { store } from '/@/store';

export interface NotificationState {
  msgId: string,
  asyncInfo: object;
  notificationTimer: string;
  uploadInfo: any;
  uploadFlag: number;
  queueList: any;
  paymentImportFlag: string;
  notifyOPenFlag: object;
  msgIsFirstLoad: Boolean;
  msgDrawerOpened: Boolean;
  asynctaskDrawerOpened: Boolean;
  newsFileParseFlag: string;
}

export const useNotificationStore = defineStore({
  id: 'app-notification',
  state: (): NotificationState => ({
    // 异步任务类型
    msgId: '',
    asyncInfo: {},
    notificationTimer: '',
    uploadInfo:[],
    uploadFlag:0,
    queueList: [],
    paymentImportFlag: '',
    notifyOPenFlag: {},
    msgIsFirstLoad: false,
    msgDrawerOpened: false,
    asynctaskDrawerOpened: false,
    newsFileParseFlag: '',
  }),
  getters: {
    getMsgId(): string {
      return this.msgId;
    },
    getAsyncInfo(): object {
      return this.asyncInfo;
    },
    getNotificationTimer(): string {
      return this.notificationTimer;
    },
    getQueueList(): any {
      return this.queueList;
    },
    getUploadList(): any {
      return this.uploadInfo;
    },
    getUploadingList(): any {
      return this.uploadInfo?.filter(item => !['finished', 'failed'].includes(item.status));
    },
    getUploadFlag(): number {
      return this.uploadFlag;
    },
    getPaymentImportFlag(): string {
      return this.paymentImportFlag
    },
    getNotifyOPenFlag(): string {
      return this.notifyOPenFlag
    },
    getMsgIsFirstLoad(): Boolean {
      return this.msgIsFirstLoad
    },
    getMsgDrawerOpened(): Boolean {
      return this.msgDrawerOpened
    },
    getAsynctaskDrawerOpened(): Boolean {
      return this.asynctaskDrawerOpened
    },
    getNewsFileParseFlag(): string {
      return this.newsFileParseFlag
    },
  },
  actions: {
    setAsyncInfo(data) {
      this.msgId = data.msgId
      this.asyncInfo = data
    },
    setNotificationNum(data) {
      this.notificationTimer = data
    },
    setQueueList(data,autoFlagChange=false){
      this.queueList = data;
      if(autoFlagChange){
        this.uploadFlag++;
      }
    },
    setUploadList(data){
      this.uploadInfo = data;
    },
    setPaymentImportFlag(data) {
      this.paymentImportFlag = data;
    },
    setNotifyOPenFlag(data) {
      this.notifyOPenFlag = data;
    },
    clearNotifyOPenFlag(saveItem = '') {
      if (!this.notifyOPenFlag?.[saveItem]) {
        this.notifyOPenFlag = {}
      }
    },
    setMsgIsFirstLoad(data) {
      this.msgIsFirstLoad = data
    },
    setMsgDrawerOpened(data) {
      this.msgDrawerOpened = data
    },
    setAsynctaskDrawerOpened(data) {
      this.asynctaskDrawerOpened = data
    },
    setNewsFileParseFlag(data) {
      this.newsFileParseFlag = data
    }
  },
});

// Need to be used outside the setup
export function useNotificationStoreWithOut() {
  return useNotificationStore(store);
}
